(function() {
  'use strict';

  angular
    .module('video.videoCtrl', [
      'video.videoDirective',
      'factories.playerControls',
      'factories.utils',
      'factories.navigationFactory'
    ])
    .controller('VideoCtrl', VideoCtrl);

  VideoCtrl.$inject = ['$scope', '$timeout', 'Utils', 'Navigation', 'MobileHelper', '$modal', 'SpinnerHelper', 'gettext',
    '$window', '$rootScope', 'translationService'];

  function VideoCtrl($scope, $timeout, Utils, Navigation, MobileHelper, $modal, SpinnerHelper, gettext, $window,
                     $rootScope, translationService) {

    var translate = translationService.sprintf;

    var states = { playing: 'playing', paused: 'paused', scrubbing: 'scrubbing', ended: 'ended', starting: 'starting' };
    var sourceTypes = {
      hd: translate(gettext('HD')),
      sd: translate(gettext('SD')),
      lowQuality: translate(gettext('LOW')),
      hls: 'HLS' // This isn't shown so no need to translate.
    };
    var fullscreenModes = { none: 'none', fullscreenApi: 'fullscreenApi', largeVideo: 'largeVideo' };
    var currentSlide = $scope.currentSlide;
    var bufferingTimeoutPromise = null;

    var videoState = $scope.mediaState = {
      states: states,
      state: states.starting,
      duration: 0,
      currentTime: 0,
      hTMLSafeConversion: false,
      hyperlinks: [],
      clickPoints: [],
      videoSrc: '',
      availableResolutions: [],
      sourceTypes: sourceTypes,
      size: null,
      buffering: false,
      showChangeResolutionNotification: false,
      fullscreenModes: fullscreenModes,
      fullscreen: fullscreenModes.none,
      deferredSeekTime: null
    };

    if (currentSlide.lowQualityContentPath) {
      videoState.availableResolutions.push(sourceTypes.lowQuality);
      if (currentSlide.videoSDWidth != currentSlide.videoLowQualityWidth ||
        currentSlide.videoSDHeight != currentSlide.videoLowQualityHeight)
        videoState.availableResolutions.push(sourceTypes.sd);
    } else if (currentSlide.sDContentPath) {
      videoState.availableResolutions.push(sourceTypes.sd);
    }

    if (currentSlide.sDContentPath) {
      if (currentSlide.videoHDWidth != currentSlide.videoSDWidth ||
        currentSlide.videoHDHeight != currentSlide.videoSDHeight)
        videoState.availableResolutions.push(sourceTypes.hd);
    } else if (currentSlide.contentPath) {
      videoState.availableResolutions.push(sourceTypes.hd);
    }

    videoState.availableResolutions = videoState.availableResolutions.reverse();

    var videoControl = $scope.mediaControl = {
      slide: currentSlide
    };

    $scope.hasStartedPlaying = false;
    $scope.willGoNativeFullScreen = MobileHelper.willGoNativeFullScreen();
    $scope.touchMobileHeight = MobileHelper.isTouch() && MobileHelper.isMobileHeight();

    // Ignore click points if we can only play in native full screen mode.
    if (currentSlide.sequencePoints && !$scope.willGoNativeFullScreen) {
      videoState.clickPoints = currentSlide.sequencePoints.split(',').map(parseFloat);

      //Clickpoints at zero cause problems when the video is trying to start playing, so nudge it forward a bit
      if (videoState.clickPoints.length && videoState.clickPoints[0] === 0)
        videoState.clickPoints[0] = 0.1;
    }

    $scope.reloadHandler.reload = function() {
      if (videoState)
        $scope.$apply(function() {
          videoState.state = states.paused;
        });
    };

    $scope.$watch('mediaState.state', function(state) {
      Navigation.showNavControls = (state === states.paused || state === states.ended || state === states.starting);
    });

    Navigation.intercept('navigate', function interceptNavigate(navigateTo) {
      // Let default handler deal with it if they're not on the native app and haven't started playing the video
      // and it's a youtube slide. Can't start playing it in this case because YouTube requires you start playback
      // by tapping on the actual video in the YouTube iframe.
      if (!$scope.hasStartedPlaying && MobileHelper.isMobileDevice() && !MobileHelper.isNativeIpadApp &&
        $scope.currentSlide.__type === 'YouTubeSlideInfo')
        return true;

      // Just go to next slide if using native full screen video player.
      if (MobileHelper.willGoNativeFullScreen())
        return true;

      if (navigateTo === Navigation.directions.next && (videoState.state === states.paused || videoState.state === states.starting)) {
        videoState.state = states.playing;
        return false;
      }
      return true;
    });

    $scope.onReadyToStartPlaying = function() {
      videoState.hyperlinks = currentSlide.hyperlinks;      //Wait until after we have video info so we can position links properly
      Navigation.state = Navigation.states.ready;
    };

    // TODO: this will be blocked by popup blocker
    $scope.hyperlinkClicked = function(url) {
      videoState.state = states.paused;
      $timeout(function() {
        Utils.viewUrl(url);
      }, 50);
    };

    $scope.showHasNoVideoTechError = function() {
      $scope.contentErrorModal = {
        message: translate(gettext('You\'re using a browser that does not support this type of content. Please upgrade your browser or install Flash.')),
        redirectToDashboard: true,
        title: translate(gettext('Unable to View Content')),
        url: $window.mfConfig ? $window.mfConfig.upgradeUrl : mfConfig.upgradeUrl
      };
      Navigation.state = Navigation.states.ready;
      SpinnerHelper.hideAllSpinners();
      $modal.open({
        templateUrl: 'contentPlayer/contentErrorModal.html',
        controller: 'ContentErrorModal',
        scope: $scope,
        backdrop: 'static'
      });
    };

    $scope.showPluginBlockedError = function() {
      $scope.contentErrorModal = {
        message: translate(gettext('Your browser may be blocking the Flash plugin that is required to play this content type. Please check that the plugin is enabled.')),
        redirectToDashboard: false,
        title: translate(gettext('Enable Flash Plugin')),
        url: $window.mfConfig ? $window.mfConfig.upgradeUrl : mfConfig.upgradeUrl
      };
      Navigation.state = Navigation.states.ready;
      SpinnerHelper.hideAllSpinners();
      $modal.open({
        templateUrl: 'contentPlayer/contentErrorModal.html',
        controller: 'ContentErrorModal',
        scope: $scope,
        backdrop: 'static'
      });
    };

    $scope.setInitialVideoSource = function(params) {
      if (!videoControl || !videoState) return;

      params = params || {};

      var outerWidth = $scope.getOuterWidth();
      var outerHeight = $scope.getOuterHeight();

      if (MobileHelper.supportsHLS() && !videoControl.slide.videoCached && !params.noHLS) {
        videoState.sourceType = videoState.sourceTypes.hls;
      } else if (!videoControl.slide.videoCached && $rootScope.sourceType &&
        !!~videoState.availableResolutions.indexOf($rootScope.sourceType)) {
        videoState.sourceType = $rootScope.sourceType;
      } else if ((outerWidth > videoControl.slide.videoSDWidth ||
          outerHeight > videoControl.slide.videoSDHeight) &&
        !!~videoState.availableResolutions.indexOf(sourceTypes.hd)) {
        videoState.sourceType = videoState.sourceTypes.hd;
      } else if ((outerWidth > videoControl.slide.videoLowQualityWidth ||
          outerHeight > videoControl.slide.videoLowQualityHeight) &&
        !!~videoState.availableResolutions.indexOf(sourceTypes.sd)) {
        videoState.sourceType = videoState.sourceTypes.sd;
      } else {
        videoState.sourceType = videoState.sourceTypes.lowQuality;
      }

      switch (videoState.sourceType) {
        case videoState.sourceTypes.hls:
          videoState.videoSrc = videoControl.slide.hLSContentPath;
          break;
        case videoState.sourceTypes.hd:
          videoState.videoSrc = videoControl.slide.contentPath;
          break;
        case videoState.sourceTypes.sd:
          videoState.videoSrc = videoControl.slide.sDContentPath;
          break;
        case videoState.sourceTypes.lowQuality:
          videoState.videoSrc = videoControl.slide.lowQualityContentPath;
          break;
      }
    };

    $scope.getTechOrder = function(params) {
      params = params || {};

      if (~$scope.cModule.name.indexOf('useHtml'))
        return ['html5'];

      var isWindows = $window.navigator.userAgent.toLowerCase().match(/win/i);

      // Only change the tech order if we think it can play HTML5 video to begin with. Otherwise, let it
      // use its own fallback capabilities to get to flash since in some browsers (notably Firefox 8)
      // changing the tech order was making it not work.
      if ($scope.hasFlash && $scope.canPlayHtml5Video && (params.forceFlash ||
          (isWindows && videoControl.slide.__type === 'PPTVideoSlideInfo' && !videoControl.slide.hTMLSafeConversion)))
        return ['flash', 'html5'];
      else if (!$scope.hasFlash && !$scope.canPlayHtml5Video)
        return null;

      return ['html5', 'flash'];
    };

    $scope.checkIfBuffering = function() {
      if (!videoControl || !videoControl.getCurrentTime)
        return;

      var currentTime = videoControl.getCurrentTime();
      var oldBuffering = videoState.buffering;
      videoState.buffering = (!$scope.hasPlayed || videoState.state == states.playing) &&
        (!$scope.lastSeenCurrentTime || currentTime == $scope.lastSeenCurrentTime);
      $scope.lastSeenCurrentTime = currentTime;

      if (oldBuffering != videoState.buffering) {
        if (videoState.buffering) {
          // Wait 10 seconds if initially loading the video. Wait 5 seconds others.
          var timeoutLength = $scope.hasPlayed ? 5000 : 10000;
          bufferingTimeoutPromise = $timeout(function() {
            videoState.showChangeResolutionNotification = lowerResolutionAvailable();
          }, timeoutLength);
        } else {
          $timeout.cancel(bufferingTimeoutPromise);
          bufferingTimeoutPromise = null;
          // Force a digest since we're coming from outside of angular.
          $timeout(function() {
            videoState.showChangeResolutionNotification = false;
          });
        }
      }
    };

    function lowerResolutionAvailable() {
      if (!videoState)
        return false;

      // User on HD and SD and/or LOW available.
      if (videoState.sourceType == videoState.sourceTypes.hd &&
        (!!~videoState.availableResolutions.indexOf(videoState.sourceTypes.sd) ||
          !!~videoState.availableResolutions.indexOf(videoState.sourceTypes.lowQuality)))
        return true;

      // User on SD and LOW available.
      if (videoState.sourceType == videoState.sourceTypes.sd &&
        !!~videoState.availableResolutions.indexOf(videoState.sourceTypes.lowQuality))
        return true;

      return false;
    }

    $scope.showNavigateNextFullscreenVideo = function() {
      return Navigation.canNavigateNext() && $scope.mediaState.fullscreen == fullscreenModes.fullscreenApi;
    };

    $scope.$on('$destroy', function() {
      if (bufferingTimeoutPromise) {
        $timeout.cancel(bufferingTimeoutPromise);
        bufferingTimeoutPromise = null;
      }
    });
  }
})();
